import { OmnitagResultItem } from 'packages/lib/api/omnitag/contract/omnitag-search';
import { atomWithReset } from 'jotai/utils';
import { atom } from 'jotai';

/**
 * Use the following helper Actions to easily modify this state:
 * toggleSelectedResultTransaction
 * selectMultipleResultsTransaction
 * deselectMultipleResultsTransaction
 *
 * Note: stores the entire OmnitagResultItem, not a key
 */
export const selectedResultsAtom = atomWithReset<Set<OmnitagResultItem>>(
  new Set()
);

export const toggleSelectedResultTransaction = atom(
  null,
  (get, set, result: OmnitagResultItem | undefined | null) => {
    if (!result) {
      return;
    }

    const newSet = new Set(get(selectedResultsAtom));
    const selectedArray = Array.from(newSet);

    const existingResult = selectedArray.find((item) => item.id === result.id);

    if (existingResult) {
      newSet.delete(existingResult);
    } else {
      newSet.add(result);
    }

    set(selectedResultsAtom, newSet);
  }
);

export const selectMultipleResultsTransaction = atom(
  null,
  (get, set, results: OmnitagResultItem[]) => {
    const newSet = new Set(get(selectedResultsAtom));
    const selectedIds = new Set(Array.from(newSet).map((r) => r.id));
    results.forEach((result) => {
      const resultId = result.id;
      if (!selectedIds.has(resultId)) {
        newSet.add(result);
      }
    });
    set(selectedResultsAtom, newSet);
  }
);

export const deselectMultipleResultsTransaction = atom(
  null,
  (get, set, results: OmnitagResultItem[]) => {
    const newSet = new Set(get(selectedResultsAtom));
    const selectedArray = Array.from(newSet);

    results.forEach((result) => {
      const resultToDelete = selectedArray.find(
        (item) => item.id === result.id
      );
      if (resultToDelete) newSet.delete(resultToDelete);
    });
    set(selectedResultsAtom, newSet);
  }
);
